import SiteHeader from '../../features/headers/site-header';
import SiteFooter from '../../features/footer/site-footer';
import PrivacyPolicy from '../../features/legal/layouts/privacy-policy';

export default function PrivacyPolicyPage() {
    return (
        <>
            <a className="skip-link" href="#contenido">Saltar al contenido</a>
            <SiteHeader />
            <main id="contenido">
                <PrivacyPolicy />
            </main>
            <SiteFooter />
        </>
    );
}
